export enum EnumTypeResponse {
    Success = 0,
    Info = 1,
    Alert = 2,
    Error = 3
}